import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Body.css';

import Header from './js/Components/Header';
import Footer from './js/Components/Footer';
import Home from './js/Pages/Home';
import About from './js/Pages/About';
import Contact from './js/Pages/Contact';
import PhotoGallery from './js/Pages/Gallery';
import Account from './js/Pages/Account';
import AdminPanel from './js/Pages/Admin/AdminPanel';

const AppShell: React.FC = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/AdminPanel');
  const variant: 'container' | 'admin' = isAdminRoute ? 'admin' : 'container';
  const [isAdminSidebarCollapsed, setIsAdminSidebarCollapsed] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!isAdminRoute) {
      setIsAdminSidebarCollapsed(false);
    }
  }, [isAdminRoute]);

  return (
    <>
      <div className={`app-shell app-shell-${variant} ${isAdminSidebarCollapsed ? 'admin-sidebar-collapsed' : ''}`}>
        <Header
          variant={variant}
          isAdminSidebarCollapsed={isAdminSidebarCollapsed}
          onToggleAdminSidebar={() => setIsAdminSidebarCollapsed((currentValue) => !currentValue)}
        />

        <main className={`main-content main-content-${variant}`}>
          <Routes>
            <Route path="/Account" element={<Account />} />
            <Route path="/About" element={<About />} />
            <Route path="/Gallery" element={<PhotoGallery />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/AdminPanel/*" element={<AdminPanel />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
      </div>
      <Footer variant={variant} />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
